import { FC } from 'react';

import IconRefresh from 'src/assets/images/icons/refresh.svg';
import { INotifDetailSectionLoaderProps } from './types';
import { NotificationDetailSection } from './Section';

export const NotificationDetailSectionLoader: FC<INotifDetailSectionLoaderProps> = (props) => {
  const { data, children, defaultExpanded = true } = props;

  return (
    <NotificationDetailSection
      defaultExpanded={defaultExpanded}
      header={
        <div className='flex items-center gap-16'>
          <div className='w-[28px] h-[28px] rounded-full bg-[#EBEEF0] border border-[#597282] flex items-center justify-center'>
            <img src={IconRefresh} className='animate-spin-reverse w-[16px]' alt='' />
          </div>
          <div className='flex items-center gap-8'>
            <div className='flex-1 text-16 font-medium text-neutral-70'>Loading / Processing</div>
            {data?.invoiceGroups && data.invoiceGroups.length > 0 && (
              <>
                <div className='w-4 h-4 bg-blue_grey-30 rounded-full' />
                <div className='text-12 xl:text-14 font-bold'>
                  {data.invoiceGroups.reduce((count, invoiceGroup) => count + (invoiceGroup.invoiceFileProcessingStatusList?.length || 0), 0)} items
                </div>
              </>
            )}
          </div>
        </div>
      }
    >
      {children}
    </NotificationDetailSection>
  );
};
